<template>
  <div id="app" :class="`${theme}-theme`">
    <router-view />
    <EmbedPageOverlay />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import EmbedPageOverlay from '@/components/EmbedPageOverlay.vue';

export default {
  name: 'app',
  components: {
    EmbedPageOverlay,
  },
  computed: {
    ...mapGetters(['user', 'theme']),
    ...mapState(['settings']),
    // nextRoute() {
    //   return this.$route.query.redirect || '/';
    // },
  },
  async mounted() {
    this.$i18n.locale = this.settings.locale;

    try {
      await this.$store.dispatch('fetchConfig');
      await this.$store.dispatch('fetchInstructionVideos');
    } catch (e) {
      console.log(e);
    }
  },
  watch: {
    // user(auth) {
    //   if (auth) {
    //     this.$router.replace(this.nextRoute);
    //   }
    // },
    $route(to, from) {
      const query = Object.assign({}, to.query);
      this.$store.commit('SETUP_URL_SETTINGS', query);
    },
    'settings.locale'(value) {
      this.$i18n.locale = value;
    },
  },
};
</script>
<style lang="scss">
.light-theme {
  .ant-layout-content {
    background-color: #e1f5fe;
    .content-page {
      min-height: calc(100vh - 626px);
      padding: 1rem;

      .ant-card-head-title {
        font-size: 20px;
      }
    }
  }
}
.dark-theme {
  .ant-layout {
    background-color: #454545;
    .ant-layout-content {
      .ant-card.style3 {
        border-color: #ffb612;
        .ant-card-head {
          background-color: #ffb612;
          border-color: #ffb612;
        }
      }
    }
  }
  .ant-layout-footer {
    background-color: #454545;
    p,
    div {
      color: white;
    }
  }
}

.ant-card {
  margin-bottom: 20px;
  border-radius: 5px;
  &.style1 {
    border-color: #23c6c8;
    .ant-card-head {
      background-color: #23c6c8;
      border-color: #23c6c8;
      color: #fff;
    }
  }
  &.style2 {
    border-color: #1ab394;
    .ant-card-head {
      background-color: #1ab394;
      border-color: #1ab394;
      color: #fff;
    }
  }
  &.style3 {
    border-color: #1c84c6;
    .ant-card-head {
      background-color: #1c84c6;
      border-color: #1c84c6;
      color: #fff;
    }
  }
  &.style4 {
    border-color: #161537;
    .ant-card-head {
      background-color: #161537;
      border-color: #161537;
      color: #fff;
    }
  }
  &-head {
    &-title {
      font-size: 24px;
    }
  }
  img,
  iframe {
    width: 100%;
  }
}
.ant-layout-footer {
  padding: 24px 0;
}

.ant-card {
  font-size: 18px;
}
.imageHeader {
  width: 100%;
  max-width: 100px;
  margin: auto;
  display: block;
}
.formForgot {
  .ant-tag-red {
    width: 100%;
    margin-bottom: 10px;
    white-space: initial;
    line-height: initial;
  }
}
.content-page {
  .reset-padding {
    // border: none;
    .ant-card-body {
      padding: 5px;
    }
  }
  &.introduction {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
// .ba-videorecorder-chooser-button-0,
// .ba-videorecorder-chooser-button-2 {
//   border: 1px solid #007aff;
//   transition: all 0.2s ease-in-out !important;
//   &:hover {
//     background-color: #fff;
//     color: #007aff;
//     box-shadow: 0 0 5px 2px rgba(#007aff, 0.6) !important;
//   }
// }
// .ba-recorder-blue-color .ba-videorecorder-chooser-button-0,
//   .ba-recorder-blue-color .ba-videorecorder-chooser-button-1,
//   .ba-recorder-blue-color .ba-videorecorder-chooser-button-2,
//   .ba-recorder-blue-color .ba-videorecorder-chooser-button-3 {
//     background: #fff;
//     color: #2a74eb;
//     &:hover {
//       background: #2a74eb;
//       color: #fff;
//     }
//   }
.ba-recorder-blue-color .ba-videorecorder-chooser-button-3 {
  margin-top: 1rem;
}
.ba-recorder-blue-color .ba-videorecorder-chooser-button-0,
.ba-recorder-blue-color .ba-videorecorder-chooser-button-2,
.ba-recorder-blue-color .ba-videorecorder-chooser-button-1,
.ba-recorder-blue-color .ba-videorecorder-chooser-button-3 {
  margin: 1rem 0;
  border: 1px solid #007aff;
  border-radius: 4px;
  transition: all 0.2s ease-in-out !important;
  padding: 12px;
  background: #fff;
  color: #2a74eb;
  &:hover {
    background-color: #007aff;
    color: #fff;
    box-shadow: 0 0 5px 2px rgba(#007aff, 0.6) !important;
  }
}
.ba-videorecorder-centerbutton-container {
  position: absolute;
}

.responsive-embed {
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 30px;
  height: 0;
  overflow: hidden;

  iframe,
  object,
  embed,
  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.video-js {
  background-color: transparent !important;
  width: 100%;
  height: 100%;
  border-radius: 12px;
}

i.menu-badge {
  color: #ff0000 !important;
  margin-left: 4px;
  font-size: 16px;
}

.font-helvetica {
  font-family: Helvetica;
  font-style: italic;
}
</style>
